/* istanbul ignore file */
export const GA_TRACKING_ID = 'G-TEEBN93NPF';

// util function to track page view
export const pageview = (url, page) => {
  if (typeof window !== undefined) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: page,
    });
  }
};

// util function to track events
export const event = ({ action, category, label, value }) => {
  if (typeof window !== undefined) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
